import { combineReducers } from "redux";
import adminReducer from "./admin/reducer";
import spinnerReducer from "./spinner/reducer";
import redeemReducer from "./redeem/reducer";
import userReducer from "./user/reducer";
import { sellerReducer } from "./seller/seller.reducer";
import { historyReducer } from "./history/history.reducer";

export default combineReducers({
  admin: adminReducer,
  user:userReducer,
  history:historyReducer,
  redeem: redeemReducer,
  sellerCoin :sellerReducer,
  spinner: spinnerReducer,
});
